import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type {
  RawCommonCodesMultiResponse,
  RawCommonCodesParams,
  RawCommonCodesResponse,
  RequestOptions,
} from '../types/common';

/**
 * 공통 코드 조회 — `/api/v2/common/*` (CommonCodeController). 전부 파라미터 없는 GET, 응답은
 * `{ codes: { code, name }[] }` 공용 형태(code↔name 라벨 매핑).
 * 발전소 코드(energy/process/check/facilities)는 여기에 없다 ([TODO:code-label]).
 */
export function createCommonApi(http: Http) {
  return {
    /** GET /api/v2/common/euser — END_USER 타입 코드 */
    /**
     * @deprecated getCodes로 대체됨
     */
    async getEuserCodes(options?: RequestOptions): Promise<RawCommonCodesResponse> {
      const res = await http.get<RawCommonCodesResponse>(endpoints.common.euser, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/common/bank — 은행/금융기관 코드 */
    /**
     * @deprecated getCodes로 대체됨
     */
    async getBankCodes(options?: RequestOptions): Promise<RawCommonCodesResponse> {
      const res = await http.get<RawCommonCodesResponse>(endpoints.common.bank, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/common/subs — 구독 분류 코드 */
    /**
     * @deprecated getCodes로 대체됨
     */
    async getSubsCodes(options?: RequestOptions): Promise<RawCommonCodesResponse> {
      const res = await http.get<RawCommonCodesResponse>(endpoints.common.subs, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/common/subs/status — 구독 상태 코드 */
    /**
     * @deprecated getCodes로 대체됨
     */
    async getSubsStatusCodes(options?: RequestOptions): Promise<RawCommonCodesResponse> {
      const res = await http.get<RawCommonCodesResponse>(endpoints.common.subsStatus, {
        signal: options?.signal,
      });
      return res.data;
    },

    /**
     * GET /api/v2/common/codes?parentCodes=EUSER,BANK,... — 다중 부모 공통 코드 일괄 조회.
     * 부모별 `{ parentCode, codes: { code, name }[] }` 그룹 배열. 라벨 캐시(prefetch)용.
     */
    async getCodes(
      params: RawCommonCodesParams,
      options?: RequestOptions,
    ): Promise<RawCommonCodesMultiResponse> {
      const res = await http.get<RawCommonCodesMultiResponse>(endpoints.common.codes, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
